// Vendors
import React from 'react';
// Contexts
import { useContractContextConsumerHook } from '../../contexts/contract.context';
// Enumerations
import { ContractStatesEnumeration } from '../../enumerations/contract-states.enumeration';
// Views
import { ContractView } from '../../views/contractual/contract.view';
import { ContractOtpView } from '../../views/otp/contract-otp.view';
import { PreContractView } from '../../views/pre-contractual/pre-contract.view';

const ContractOrchestratorComponent = (): React.JSX.Element => {
  const { contractState } = useContractContextConsumerHook();

  const ContractFlowComponent = {
    [ContractStatesEnumeration.CONTRACTUAL]: ContractView,
    [ContractStatesEnumeration.PRECONTRACTUAL]: PreContractView,
    [ContractStatesEnumeration.OTP]: ContractOtpView,
  }[contractState];

  return <ContractFlowComponent />;
};

export { ContractOrchestratorComponent };
